import { useCallback } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import {
  fetchAllNotifications,
  type NotificationGroup,
  type NotificationUnreadCounts,
} from '@/apis/shipment';

export type NotificationFilter = 'all' | 'mentions';

export const UPDATES_INBOX_QUERY_KEY = ['updates-inbox'] as const;

export const getUpdatesInboxQueryKey = (filter: NotificationFilter) => [
  ...UPDATES_INBOX_QUERY_KEY,
  filter,
];

type NotificationsResponseShape = {
  data: {
    data: {
      data: NotificationGroup[];
      unread_counts: NotificationUnreadCounts;
    };
  };
};

export const getUpdatesInboxPayload = (
  res: NotificationsResponseShape
): {
  groups: NotificationGroup[];
  unreadCounts: NotificationUnreadCounts;
} => ({
  groups: res.data.data.data,
  unreadCounts: res.data.data.unread_counts,
});

export const useUpdatesInbox = ({
  token,
  filter,
}: {
  token: string;
  filter: NotificationFilter;
}) =>
  useQuery({
    queryKey: getUpdatesInboxQueryKey(filter),
    queryFn: () =>
      (filter === 'mentions'
        ? fetchAllNotifications(token, 'mentions')
        : fetchAllNotifications(token)
      ).then(getUpdatesInboxPayload),
    enabled: Boolean(token),
  });

export const useRefreshUpdatesInbox = () => {
  const queryClient = useQueryClient();

  return useCallback(
    () => queryClient.invalidateQueries({ queryKey: UPDATES_INBOX_QUERY_KEY }),
    [queryClient]
  );
};
